import aInCircle from './a-in-circle.svg?raw';
import addInCircle from './add-in-circle.svg?raw';
import add from './add.svg?raw';
import arrowDown2 from './arrow-down-2.svg?raw';
import arrowDown from './arrow-down.svg?raw';
import arrowLeft2 from './arrow-left-2.svg?raw';
import arrowLeft from './arrow-left.svg?raw';
import arrowRight2 from './arrow-right-2.svg?raw';
import arrowRight from './arrow-right.svg?raw';
import arrowUp2 from './arrow-up-2.svg?raw';
import arrowUp from './arrow-up.svg?raw';
import attach from './attach.svg?raw';
import attentionInTriangle from './attention-in-triangle.svg?raw';
import attention from './attention.svg?raw';
import bookmark from './bookmark.svg?raw';
import brightness from './brightness.svg?raw';
import burger from './burger.svg?raw';
import calendarAdd from './calendar-add.svg?raw';
import calendar from './calendar.svg?raw';
import call from './call.svg?raw';
import cameraOff from './camera-off.svg?raw';
import camera from './camera.svg?raw';
import change from './change.svg?raw';
import chat from './chat.svg?raw';
import checkboxInCircle from './checkbox-in-circle.svg?raw';
import checkboxIndeterminate from './checkbox-indeterminate.svg?raw';
import checkbox from './checkbox.svg?raw';
import closeInCircle from './close-in-circle.svg?raw';
import close from './close.svg?raw';
import defaultIcon from './default.svg?raw';
import download2 from './download-2.svg?raw';
import downloadInSquare from './download-in-square.svg?raw';
import download from './download.svg?raw';
import dropdownInline from './dropdown-inline.svg?raw';
import dropdownUp from './dropdown-up.svg?raw';
import dropdown from './dropdown.svg?raw';
import favorite from './favorite.svg?raw';
import flag from './flag.svg?raw';
import folder from './folder.svg?raw';
import forward from './forward.svg?raw';
import grammar from './grammar.svg?raw';
import groupOfPeople from './group-of-people.svg?raw';
import heart from './heart.svg?raw';
import hide from './hide.svg?raw';
import info from './info.svg?raw';
import key from './key.svg?raw';
import learned from './learned.svg?raw';
import lightning from './lightning.svg?raw';
import link from './link.svg?raw';
import list4 from './list-4.svg?raw';
import listening from './listening.svg?raw';
import loader from './loader.svg?raw';
import lock from './lock.svg?raw';
import login from './login.svg?raw';
import message from './message.svg?raw';
import microphoneOff from './microphone-off.svg?raw';
import microphone from './microphone.svg?raw';
import minus from './minus.svg?raw';
import mobile from './mobile.svg?raw';
import more from './more.svg?raw';
import notification from './notification.svg?raw';
import paragraphBulletList from './paragraph-bullet-list.svg?raw';
import paragraphJustify from './paragraph-justify.svg?raw';
import pause from './pause.svg?raw';
import payment from './payment.svg?raw';
import peopleAdd from './people-add.svg?raw';
import pinPost from './pin-post.svg?raw';
import pinWithTime from './pin-with-time.svg?raw';
import pin from './pin.svg?raw';
import play from './play.svg?raw';
import portfolio from './portfolio.svg?raw';
import profile from './profile.svg?raw';
import pronunciation from './pronunciation.svg?raw';
import question from './question.svg?raw';
import refresh from './refresh.svg?raw';
import sInCircle from './s-in-circle.svg?raw';
import screenScaleDown2 from './screen-scale-down-2.svg?raw';
import screenScaleUp2 from './screen-scale-up-2.svg?raw';
import searchPerson from './search-person.svg?raw';
import share from './share.svg?raw';
import shield from './shield.svg?raw';
import show from './show.svg?raw';
import sparcle from './sparcle.svg?raw';
import speakers from './speakers.svg?raw';
import stats from './stats.svg?raw';
import switchIcon from './switch.svg?raw';
import tInCircle from './t-in-circle.svg?raw';
import target2 from './target-2.svg?raw';
import thumbUp from './thumb-up.svg?raw';
import tick from './tick.svg?raw';
import timeSecondary from './time-secondary.svg?raw';
import time from './time.svg?raw';
import trashBin from './trash-bin.svg?raw';
import typingInBubble from './typing-in-bubble.svg?raw';
import video from './video.svg?raw';
import vocabulary2 from './vocabulary-2.svg?raw';
import vocabulary from './vocabulary.svg?raw';
import volume from './volume.svg?raw';
import wordAdded from './word-added.svg?raw';
import wordInProgress from './word-in-progress.svg?raw';
import writing2 from './writing-2.svg?raw';
import writing3 from './writing-3.svg?raw';
import zoom from './zoom.svg?raw';

export const smallIcons: Record<string, string> = {
  'a-in-circle': aInCircle,
  'add-in-circle': addInCircle,
  add: add,
  'arrow-down-2': arrowDown2,
  'arrow-down': arrowDown,
  'arrow-left-2': arrowLeft2,
  'arrow-left': arrowLeft,
  'arrow-right-2': arrowRight2,
  'arrow-right': arrowRight,
  'arrow-up-2': arrowUp2,
  'arrow-up': arrowUp,
  attach: attach,
  'attention-in-triangle': attentionInTriangle,
  attention: attention,
  bookmark: bookmark,
  brightness: brightness,
  burger: burger,
  'calendar-add': calendarAdd,
  calendar: calendar,
  call: call,
  'camera-off': cameraOff,
  camera: camera,
  change: change,
  chat: chat,
  'checkbox-in-circle': checkboxInCircle,
  'checkbox-indeterminate': checkboxIndeterminate,
  checkbox: checkbox,
  'close-in-circle': closeInCircle,
  close: close,
  default: defaultIcon,
  'download-2': download2,
  'download-in-square': downloadInSquare,
  download: download,
  'dropdown-inline': dropdownInline,
  'dropdown-up': dropdownUp,
  dropdown: dropdown,
  favorite: favorite,
  flag: flag,
  folder: folder,
  forward: forward,
  grammar: grammar,
  'group-of-people': groupOfPeople,
  heart: heart,
  hide: hide,
  info: info,
  key: key,
  learned: learned,
  lightning: lightning,
  link: link,
  'list-4': list4,
  listening: listening,
  loader: loader,
  lock: lock,
  login: login,
  message: message,
  'microphone-off': microphoneOff,
  microphone: microphone,
  minus: minus,
  mobile: mobile,
  more: more,
  notification: notification,
  'paragraph-bullet-list': paragraphBulletList,
  'paragraph-justify': paragraphJustify,
  pause: pause,
  payment: payment,
  'people-add': peopleAdd,
  'pin-post': pinPost,
  'pin-with-time': pinWithTime,
  pin: pin,
  play: play,
  portfolio: portfolio,
  profile: profile,
  pronunciation: pronunciation,
  question: question,
  refresh: refresh,
  's-in-circle': sInCircle,
  'screen-scale-down-2': screenScaleDown2,
  'screen-scale-up-2': screenScaleUp2,
  'search-person': searchPerson,
  share: share,
  shield: shield,
  show: show,
  sparcle: sparcle,
  speakers: speakers,
  stats: stats,
  switch: switchIcon,
  't-in-circle': tInCircle,
  'target-2': target2,
  'thumb-up': thumbUp,
  tick: tick,
  'time-secondary': timeSecondary,
  time: time,
  'trash-bin': trashBin,
  'typing-in-bubble': typingInBubble,
  video: video,
  'vocabulary-2': vocabulary2,
  vocabulary: vocabulary,
  volume: volume,
  'word-added': wordAdded,
  'word-in-progress': wordInProgress,
  'writing-2': writing2,
  'writing-3': writing3,
  zoom: zoom,
};
